import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Grid } from '@chakra-ui/react';
import React from 'react';
import { convertToCSS, getPaddingValue } from '@/utils';
export const getColumnsTemplate = (columns) => columns
    .map((col) => {
    if (col === null || col === void 0 ? void 0 : col.span) {
        return `repeat(${col.span}, 1fr)`;
    }
    return '1fr';
})
    .join(' ');
export const LayoutContainerColumnsBlock = ({ block, renderBlock }) => {
    const { id, padding, layout_config: { columns, gap, min_column_width } } = block;
    const styles = convertToCSS({ padding });
    const gridGap = getPaddingValue(gap);
    const templateColumns = getColumnsTemplate(columns);
    return (_jsx(Grid, Object.assign({ "data-test": id, sx: styles, gap: gridGap, templateColumns: {
            base: '1fr',
            md: min_column_width
                ? `repeat(auto-fit, minmax(${min_column_width}, 1fr))`
                : templateColumns
        } }, { children: columns.map((column, index) => {
            var _a, _b;
            return (_jsx(Box, Object.assign({ gridColumn: `span ${column.span}`, minWidth: column.min_width }, { children: column.blocks.map((block) => (_jsx(React.Fragment, { children: renderBlock(block) }, block.id))) }), `column-${index}-${(_b = (_a = column.blocks[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : index}`));
        }) })));
};
